/* eslint-disable */
import React, { createRef, useState, useEffect } from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import ReactIdSwiper from 'react-id-swiper';
import Fade from 'react-reveal/Fade';
import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm';
import { gsap, ScrollToPlugin, TweenLite } from 'gsap/all';
import { GalleryPage } from '~/sections/GalleryPage';
import { DataLayer } from '~/components/DataLayer';
import { Quote } from '~/components/Quote';
import { PaperClip } from '~/components/PaperClip';
import configData from '~/config/data';
import { AccordionTab, TabContent, DesktopTabs } from './Info';
import css from './AboutPage.scss';

gsap.registerPlugin(ScrollToPlugin);

const classes = {
	root: css.aboutPage,
	content: css.aboutPageContent,
	paperClip: css.aboutPagePaperClip,
	accordion: css.aboutPageAccordion,
	accordionTitle: css.aboutPageAccordionTitle,
	accordionList: css.aboutPageAccordionList,
	accordionItem: css.aboutPageAccordionItem,
	accordionContent: css.aboutPageTabContent,
	quoteMobile: css.aboutPageQuoteMobile,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	data: PropTypes.object,
};

const defaultProps = {
	className: '',
	classes,
	data: configData.about,
};

export function AboutPage({ className, classes, data: info, ...props }) {
	const $el = createRef();
	const [data, setData] = useState(info.data);

	const onClickGalleryTab = (evt, title, opened) => {
		DataLayer.push('AboutPage_ClicouTabMobile', title, opened);
	};

	const onClickTab = (evt, title, opened) => {
		DataLayer.push('AboutPage_ClicouTabMobile', title, opened);
	};

	const renderItem = (item, index) => {
		return (
			<React.Fragment key={index}>
				{item.slug && <div id={item.slug} data-ui-anchor={item.slug} />}
				<AccordionTab
					className={cls(classes.accordionItem)}
					title={item.title}
					opened={item.opened}
					onClick={onClickTab}>
					<TabContent {...props} className={cls(classes.accordionContent)} data={item} />
				</AccordionTab>
			</React.Fragment>
		);
	};

	return (
		<section
			ref={$el}
			id={AboutPage.displayName}
			data-ui-anchor={AboutPage.displayName}
			className={cls(classes.root, className)}>
			{/* Decoration ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			<PaperClip
				className={cls(classes.paperClip)}
				stripes={'#FF7D32'}
				align={PaperClip.ALIGN_RIGHT}
			/>

			{/* Accordion ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			<div className={cls(classes.accordion)}>
				{props.mobile && (
					<div className={cls(classes.accordionList)}>
						<Quote className={classes.quoteMobile} title={"¡Conocé los detalles de tu próxima camioneta!"} text={"teste"} />

						{props.mobile && (
							<AccordionTab
								className={cls(classes.accordionItem)}
								title={'FOTOS'}
								icon={true}
								opened={true}
								locked={false}
								onClick={onClickGalleryTab}>
								<GalleryPage className={cls(classes.accordionContent)} {...props} />
							</AccordionTab>
						)}
						{data.list.map(renderItem)}
					</div>
				)}
				{!props.mobile && (
					<Fade>
						<DesktopTabs data={data.list} />
					</Fade>
				)}
			</div>
		</section>
	);
}

AboutPage.displayName = 'AboutPage';
AboutPage.propTypes = propTypes;
AboutPage.defaultProps = defaultProps;
export default AboutPage;
